import { render } from "./productSeleectUrl.vue?vue&type=template&id=761ae9f0&ts=true"
import script from "./productSeleectUrl.vue?vue&type=script&lang=ts"
export * from "./productSeleectUrl.vue?vue&type=script&lang=ts"

import "./productSeleectUrl.vue?vue&type=style&index=0&id=761ae9f0&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__